export const Cards = [
    '/images/cards/amex.png',
    '/images/cards/discover.png',
    '/images/cards/Google_Pay.png',
    '/images/cards/matser.png',
    '/images/cards/Paypal.png',
    '/images/cards/visa.png',
    '/images/cards/Venmo.png',
    '/images/cards/mpay.png'
  ];